import React, { Fragment } from 'react'
import { getCountryInfo } from '../../helpers/tel-helpers'
import classNames from 'classnames'

export const FLAG_OTHER = 'OT'
const countriesList = ['RU', 'KZ', 'AM', 'BY', 'KG', 'AZ', 'GE', 'MD', 'TJ', 'TM', 'UZ', 'UA', FLAG_OTHER]

export const TelFlags = ({ onClick, hideCountry, roundIcon = false }) => {
  return (
    <ul className='g-ul head-actions'>
      {countriesList.map((item, key) => {
        if (hideCountry && hideCountry === item) {
          return null
        }
        const country = getCountryInfo(item)
        const telCode = country.mask.replace(/\\/g, '').replace(/(\+\d+)\D.*/, '$1')
        const flagIconClasses = classNames(`country with-icon_${country.name_en.toLowerCase()}`, {
          'with-icon-flag': roundIcon,
        })
        return (
          <li
            key={key}
            className={flagIconClasses}
            onClick={e => onClick({ e, country })}
          >
            {!roundIcon && (
              <span className='link link__pseudo'>
                {country.name_ru.replace(/\(.*/, '')} {telCode && country.cc !== 'OT' && `(${telCode})`}
              </span>
            )}
            {roundIcon && (
              <Fragment>
                <span className='country-name'>{country.name_ru.replace(/\(.*/, '')}</span>
                <span className='tel-code'>{telCode && country.cc !== 'OT' && `${telCode}`}</span>
              </Fragment>
            )}
          </li>
        )
      })}
    </ul>
  )
}
